(function () {
    const TEST_CONFIG = {
        id: 'SB022DM',
        name: 'Sidecart: Product Recommendations vs Category Cards',
        variation: 1,
        selector: '[class*="styles_CartPreview__empty__"]',
        variationClass: '.SB022DM'
    };
    const helpers = {
        waitForElem: function (waitFor, callback, minElements = 1, isVariable = false, timer = 10000, frequency = 25) {
            const $this = this;
            let elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
            if (timer <= 0) return;
            (!isVariable && elements.length >= minElements) ||
                (isVariable && typeof window[waitFor] !== 'undefined')
                ? callback(elements)
                : setTimeout(
                    () => $this.waitForElem(waitFor, callback, minElements, isVariable, timer - frequency),
                    frequency
                );
        },
        insertAfter: function (el, html) {
            if (!el || !html) return;
            el.insertAdjacentHTML('afterend', html);
        },
        insertBefore: function (el, html) {
            if (!el || !html) return;
            el.insertAdjacentHTML('beforebegin', html);
        },
        buildItemsList: function (data = [], html) {
            if (!Array.isArray(data) || typeof html !== 'function') return '';
            return data.map((item) => html(item)).join('');
        },
        isMobileScreen: function () {
            return window.innerWidth <= 768;
        },
        debounce: function (func, wait) {
            let timeout;
            let called = false;
            return function (...args) {
                const context = this;
                if (!called) {
                    func.apply(context, args);
                    called = true;
                }
                clearTimeout(timeout);
                timeout = setTimeout(() => { called = false; }, wait);
            };
        },
    };
    const MELLOW_RECS = [
        {
            name: 'CloudAlign Pillow',
            image: '//mellowsleep.com/cdn/shop/files/CloudAlign_Hero_3.webp?v=1778538860&width=450',
            stars: 5,
            reviews: 34672,
            originalPrice: '$100.00',
            salePrice: '$49.00',
            url: '/products/cloud-alignment-pillow'
        },
        {
            name: 'MarshMellow Comforter',
            image: '//mellowsleep.com/cdn/shop/files/Hero_New.jpg?format=webp&v=1762914324&width=450',
            stars: 5,
            reviews: 10876,
            originalPrice: '$200.00',
            salePrice: '99.99',
            url: '/products/marshmellow-comforter'
        },
        {
            name: 'Hotel Pillow',
            image: '//mellowsleep.com/cdn/shop/files/herooooo_1.jpg?format=webp&v=1772655784&width=450',
            stars: 5,
            reviews: 6741,
            originalPrice: '$59.99',
            salePrice: '$29.99',
            url: '/products/mellow-hotel-pillow'
        },
        {
            name: 'Cooling Comforter',
            image: '//mellowsleep.com/cdn/shop/files/Coolingcomforterr.png?format=webp&v=1778509858&width=450',
            stars: 5,
            reviews: 2463,
            originalPrice: '$129.00',
            salePrice: '$79.99',
            url: '/products/cloud-cold-comforter-white'
        }
    ];
    const SB022DM = {
        init: function () {
            this.mainCSS();
            this.mainJS();
        },
        mainCSS: function () {
            const styleId = `${TEST_CONFIG.id}-ab-styles`;
            if (document.getElementById(styleId)) return;
            const css = `
                body${TEST_CONFIG.variationClass} .upcart-public-upsell__vertical-layout-wrapper,
                body${TEST_CONFIG.variationClass} .upcart-public-upsell__title,
                body${TEST_CONFIG.variationClass} .styles_CartPreview__empty__ > h3 {
                  display: none !important;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs {
                    display: none;
                    width: 100%;
                    box-sizing: border-box;
                    font-family: 'Inter', sans-serif;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-header {
                    background-color: #E8E6F4;
                    padding: 18px 16px 8px;
                    text-align: center;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-header h2 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 400;
                    color: #4C4184;
                    line-height: normal;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-header p {
                    margin: 0;
                    font-size: 14px;
                    color: #1B2025;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-list {
                    background-color: #E8E6F4;
                    padding: 8px 12px 16px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-card {
                    background: #ffffff;
                    border-radius: 12px;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    text-decoration: none;
                    box-shadow: 0 1px 4px rgba(58,47,122,0.07);
                    transition: box-shadow 0.2s;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-card:hover {
                    box-shadow: 0 3px 10px rgba(58,47,122,0.14);
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-card img {
                    width: 72px;
                    height: 72px;
                    object-fit: cover;
                    flex-shrink: 0;
                    background: #f0eff8;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-info {
                    flex: 1;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    font-family: 'Inter';
                    line-height: normal;
                    align-self: flex-start;
                    gap: 4px;
                    height: 72px;
                    padding: 5px 0;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-name {
                    font-size: 15px;
                    font-weight: 700;
                    color: #4C4184;
                    line-height: 1.3;
                    white-space: nowrap;
                    overflow: hidden;
                    font-family: 'MelbourneRegular';
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-stars {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-stars .stars {
                    color: #4C4184;
                    font-size: 13px;
                    letter-spacing: 1px;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-stars .review-count {
                    font-size: 12px;
                    color: #4C4184;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-prices {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: auto;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-original {
                    font-size: 12px;
                    color: #4C4184;
                    text-decoration: line-through;
                    opacity: .8;
                }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-sale {
                    font-size: 15px;
                    color: #4C4184;
                }
                body${TEST_CONFIG.variationClass} .mer-shop-now {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: 400;
                    color: #4c4184;
                    text-decoration: underline;
                    text-underline-offset: 2px;
                }
                body${TEST_CONFIG.variationClass} .mer-shop-now:hover {
                    color: #3a2f7a;
                }
                body${TEST_CONFIG.variationClass} .mer-prices .mer-shop-now{
                  display:flex;
                  margin-left: auto;
                }    
                body${TEST_CONFIG.variationClass} .mer-info > .mer-shop-now{
                  display:none;
                }                 
                @media (max-width:440px){
                  body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-info {
                    height:80px;
                    padding: 0;
                    gap: 2px;
                  }
                body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-card img {
                    width: 80px;
                    height: 80px;
                }
                  body${TEST_CONFIG.variationClass} .mer-prices .mer-shop-now{
                    display:none;
                  }
                  body${TEST_CONFIG.variationClass} .mer-info > .mer-shop-now{
                    display:inline-block;
                  }                  
                }
                @media (max-width:380px){
                  body${TEST_CONFIG.variationClass} #mellow-empty-recs .mer-list{
                        padding-bottom: 0;
                  }
                }
            `;
            const style = document.createElement('style');
            style.id = styleId;
            style.setAttribute('data-ab-test', TEST_CONFIG.id);
            style.textContent = css;
            document.head.appendChild(style);
        },
        mainJS: function () {
            document.body.classList.add(TEST_CONFIG.id);
            const self = this;
            function renderStars(count) {
                const full = Math.round(count);
                return '★'.repeat(full) + '☆'.repeat(5 - full);
            }
            function fmt(n) {
                return n.toLocaleString();
            }
            function buildRecsHTML() {
                const cards = helpers.buildItemsList(MELLOW_RECS, function (p) {
                    return `
                        <a class="mer-card" href="${p.url}" aria-label="Shop ${p.name}">
                            <img
                                src="${p.image}"
                                alt="${p.name}"
                                loading="lazy"
                                onerror="this.style.display='none'"
                            />
                            <div class="mer-info">
                                <div class="mer-name">${p.name}</div>
                                <div class="mer-stars">
                                    <span class="stars" aria-hidden="true">${renderStars(p.stars)}</span>
                                    <span class="review-count">(${fmt(p.reviews)} reviews)</span>
                                </div>
                                <div class="mer-prices">
                                    <span class="mer-original">${p.originalPrice}</span>
                                    <span class="mer-sale">${p.salePrice}</span>
                                    <span class="mer-shop-now">Shop Now</span>
                                </div>
                                <span class="mer-shop-now">Shop Now</span>
                            </div>
                        </a>
                    `;
                });
                return `
                    <div id="mellow-empty-recs"
                         aria-label="Product recommendations"
                         role="region"
                         data-ab-test="${TEST_CONFIG.id}">
                        <div class="mer-header">
                            <h2>Your cart is empty</h2>
                            <p>How about these?</p>
                        </div>
                        <div class="mer-list">${cards}</div>
                    </div>
                `;
            }
            function isCartEmpty() {
                const upCartEmpty = document.querySelector('.styles_CartPreview__empty__');
                if (upCartEmpty) return window.getComputedStyle(upCartEmpty).display !== 'none';
                const drawer = document.querySelector('cart-drawer');
                if (drawer) {
                    const msg = drawer.querySelector('.cart__empty-text, [class*="cart-empty"]');
                    if (msg) return window.getComputedStyle(msg).display !== 'none';
                }
                if (window.upcartPreloadedCart) return window.upcartPreloadedCart.item_count === 0;
                if (window.Shopify && window.Shopify.cartCount !== undefined) {
                    return window.Shopify.cartCount === 0;
                }
                return false;
            }
            function getInsertionTarget() {
                const upCartBody = document.querySelector('.styles_CartPreview__empty__body__');
                if (upCartBody) return { container: upCartBody, position: 'afterbegin' };
                const drawerInner = document.querySelector('.cart-drawer__inner');
                if (drawerInner) return { container: drawerInner, position: 'afterbegin' };
                return null;
            }
            function syncRecsVisibility() {
                const empty = isCartEmpty();
                const existing = document.getElementById('mellow-empty-recs');
                if (empty) {
                    if (!existing) {
                        const target = getInsertionTarget();
                        if (target) target.container.insertAdjacentHTML(target.position, buildRecsHTML());
                    } else {
                        existing.style.display = 'block';
                    }
                } else {
                    if (existing) existing.style.display = 'none';
                }
            }
            const cartRoot =
                document.getElementById('upCart') ||
                document.getElementById('CartPopup') ||
                document.querySelector('cart-drawer') ||
                document.body;
            const observer = new MutationObserver(helpers.debounce(syncRecsVisibility, 50));
            observer.observe(cartRoot, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style', 'data-cart-empty']
            });
            let lastItemCount = null;
            setInterval(function () {
                fetch('/cart.js')
                    .then(function (r) { return r.json(); })
                    .then(function (cart) {
                        if (cart.item_count !== lastItemCount) {
                            lastItemCount = cart.item_count;
                            syncRecsVisibility();
                        }
                    })
                    .catch(function () {});
            }, 2000);
            ['cart:change', 'cart:refresh', 'upcart:open', 'upcart:cart-update'].forEach(function (evt) {
                document.addEventListener(evt, syncRecsVisibility);
            });
            syncRecsVisibility();
        },
    };
    helpers.waitForElem(TEST_CONFIG.selector, function () {
        if (document.querySelector(TEST_CONFIG.variationClass)) return;
        console.log(`${TEST_CONFIG.id} - ${TEST_CONFIG.name} - Variation ${TEST_CONFIG.variation}`);
        SB022DM.init();
    });
})();